import React, {useEffect} from "react";
import {useFormik} from "formik";
import {useAlert} from 'react-alert';
import {useHistory} from "react-router-dom";
import Loader from "../common/views/Loader";
import {InitialMessageValues, MessageSchema} from "../common/types/Schemas";
import {BYInput} from "../common/inputs/BYInput";
import {useMessage, useUpdateMessage} from "../api/hooks";
import {Animated} from "react-animated-css";
import Footer from "../common/views/Footer";
import BYDatePicker from "../common/inputs/BYDatePicker";

interface MessageIndexProps {
    match: {
        params: {
            id: string;
        }
    }
}

export const MessageIndex = (props: MessageIndexProps) => {
    const alert = useAlert();
    const history = useHistory();
    const messageId = Number(props.match.params.id);
    const isNew = props.match.params.id === 'new';

    const {mutateAsync: mutateMessage} = useUpdateMessage();
    const {data: message, isLoading} = useMessage(messageId);

    const formik = useFormik({
        initialValues: InitialMessageValues,
        validationSchema: MessageSchema,
        onSubmit: async (values) => {
            try {
                await mutateMessage({messageId, values});

                alert.success(`Message mis à jour`);

                history.goBack();
            } catch (error) {
                const statusCode = error.response && error.response.status;

                if (statusCode === 401) {
                    alert.error('Valeurs invalides ou incomplètes');
                } else if (statusCode === 409) {
                    alert.error(error.response.data);
                } else {
                    alert.error(error.message);
                }
            }
        }
    });

    useEffect(() => {
        if (message) {

            formik.setValues({
                message: message.message,
                dateFin: message.dateFin
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    if (isLoading) {
        return <div className="text-center my-6"><Loader/></div>;
    }

    return (
        <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
            <div className="container">
                <form onSubmit={formik.handleSubmit} autoComplete="new-password">
                    <div className="row">
                        <div className="col-12">
                            <h4 className="my-4 color-green">{isNew ? 'Création de nouveau message' : 'Modification de message'}</h4>
                        </div>
                    </div>
                    <div className="input-container">
                        <div className="mb-3">
                            <BYInput
                                type="textarea"
                                name="message"
                                title="Message"
                                className="form-control"
                                value={formik.values.message}
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                required
                                autoFocus
                                touched={formik.touched.message}
                                error={formik.errors.message}
                            />
                        </div>
                        <div className="mb-3">
                            <BYDatePicker
                                name="mandatorySince"
                                title="Date de fin du message"
                                value={formik.values.dateFin}
                                onChange={(newValue: Date) => {
                                    formik.setValues({
                                        ...formik.values,
                                        dateFin: newValue?.toISOString()
                                    })
                                }}
                                touched={formik.touched.dateFin}
                                error={formik.errors.dateFin}
                            />
                        </div>
                    </div>

                    <div className="d-flex my-5">
                        <button className="btn btn-secondary flex-grow-1" type="submit"
                                disabled={!formik.isValid || formik.isSubmitting}>
                            Sauvegarder{' '}
                            <i className="fa fa-save"/>
                        </button>
                    </div>
                </form>
            </div>
            <Footer/>
        </Animated>
    );
};
